module.exports = __webpack_public_path__ + "img/logo-school-13.57db2704.png";